/**
 * Service: posConfigImages
 */
angular.module('acme.common.service.posConfigImages', [])
.service('PosConfigImagesService', [function() {

    return {

      model: {
        displayTime: 5,
        images: []
      },
      

      init: function() {
        return true;
      },
      
      setModel: function(model) {
        this.model = (model) ? model : { displayTime: 5, images: [] };
      },

      getModel: function() {
        return this.model;
      },

      setImages: function(images) {
        this.model.images = images;
      },

      getImages: function() {
        return this.model.images;
      },

      setDisplayTime: function(displayTime) {
        this.model.displayTime = displayTime;
      },

      getDisplayTime: function() {
        return this.model.displayTime;
      }

    };

}]);